import axios from 'axios';
import { Axios } from './Axios';

export async function updateUser(userId, userObj) {
  const url = `/users/${userId}`;
  return Axios({
    url,
    method: 'patch',
    data: userObj
  });
}

export async function fetchCitiesForIndia() {
  const url = 'https://api.countrystatecity.in/v1/countries/IN/cities';
  return axios({
    method: 'GET',
    url,
    headers: {
      'X-CSCAPI-KEY': process.env.REACT_APP_CITY_API_KEY
    }
  });
}

export async function fetchStatesForIndia() {
  const url = 'https://api.countrystatecity.in/v1/countries/IN/states';
  return axios({
    method: 'GET',
    url,
    headers: {
      'X-CSCAPI-KEY': process.env.REACT_APP_CITY_API_KEY
    }
  });
}

export async function getUserDetails(userId) {
  const url = `/users/${userId}`;
  return Axios({
    url,
    method: 'get'
  });
}
